/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

const Color = {
  Primary: "#F8B43E",
  Secondary: "#AFAFAF",
  Tertiary: "#3A53A4",

  // Font
  primaryTextColor: "#F8B43E",
  secondaryTextColor: "#737373",
  tertiaryTextColor: "#868686",
  lightTextColor: "#ffffff",
  highlightBlueTextColor: "#3A53A4",
  highlightRedTextColor: "#e50000",
  activeHighlightRedTextColor: "RGBA(229, 0, 0, 0.8)",
  highlightGreenTextColor: "#7ef524",
  darkGreenTextColor: "#58ab19",

  // Background
  primaryBackgroundColor: "#f6f6f6",
  greyBackgroundColor: "#EEEEF3",

  borderColor: "#e0e0e0",
  darkBorderColor: "#868686",
  mutedColor: "#868686",
  disabledColor: "#c0c0c0",

  tabIconDefault: "#d7d7d7",
  tabIconSelected: "#F8B43E",

  loadingColor: "#737373",

  favouriteColor: "#ff1791",
  unpaidColor: "#016B75",
  paidColor: "#009800",
  cancelledColor: "#868686",
  completedColor: "#F16722",
  progressColor: "#0069FF",
  confirmedColor: "#009800",
  takeAwayLabelColor: "#009800"
};

export default Color;



// WEBPACK FOOTER //
// ./src/utils/Color.js